import React, { useContext } from "react";
import { AppContext } from "../../../AppContext";
import styled, { css } from 'styled-components';
import Body from "./components/Body/Body";
import Header from "./components/Header/Header";
import styles from "./ModuleContainer.module.scss";
// @ts-ignore
import classNames from "classnames";
import { StyleService } from "../../services";
import { DictionaryType } from "../../types/DictionaryType";

enum ModuleVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Box = 'box',
  Variant1 = 'variant--1',
};

type PropsType = {
  children: React.ReactNode;
  classNames?: string;
  noMargin?: boolean;
  variant?: ModuleVariant;
  id?: string;
};

const ModuleContainer = (props: PropsType) => {
  const context = useContext(AppContext);

  const whitelabelingStyles = StyleService.apply('module:container', context.styles);

  return (
    <ModuleContainerSection styles={whitelabelingStyles}
    id={props.id}  
    className={classNames(
        styles.wrapper,
        props.id,
        props.classNames,
        props.variant ? styles[props.variant] : styles.primary,
        props.noMargin && styles.noMargin
      )}
    >
      {props.children}
    </ModuleContainerSection>
  );
};

const ModuleContainerSection = styled.span<{ styles: DictionaryType<string> }>`
  ${(props) =>
    css`
      --module-background-color: ${props.styles.backgroundColor}
    `}
`;

ModuleContainer.Header = Header;
ModuleContainer.Body = Body;
ModuleContainer.ModuleVariant = ModuleVariant;

export default ModuleContainer;
